export enum OptimizationObjective {
  MinCompletionTime = "minCompletionTime",
  BalanceWorks = "balanceWorks",
  Both = "both"
}
